import React from "react";

const PAGE_SIZES = [10, 25, 50];

export default function SearchBox({
    filteredClaims,
    onChange,
    placeholder = "Search…",
    ariaLabel = "Search",
    hasQuery,
    shown,
    total,           // keep same classes so styling matches
    query,
    setQuery,
    pageSize,
    setPage,
    setPageSize,
    ...rest
}) {
    return (
        <div className="claims-tools">
            {filteredClaims.length > 0 && (
                <span
                    className="sdv-count mobile-count-box"
                    aria-label={hasQuery ? `${shown} of ${total}` : `${total} ${ariaLabel}`}
                >
                    {hasQuery ? `${shown} / ${total}` : total}
                </span>
            )}

            <label className="claims-search">
                {/* search icon */}
                <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
                    <path fill="currentColor" d="M10 2a8 8 0 0 1 6.32 12.9l4.4 4.4-1.42 1.42-4.4-4.4A8 8 0 1 1 10 2m0 2a6 6 0 1 0 .001 12.001A6 6 0 0 0 10 4" />
                </svg>

                <input
                    type="text"                   // use text to avoid the native clear (×)
                    placeholder={placeholder}
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    aria-label={ariaLabel}
                    className="claims-search-input"
                />

                {query && (
                    <button
                        type="button"
                        className="claims-clear"
                        onClick={() => setQuery("")}
                        aria-label="Clear search"
                        title="Clear"
                    >
                        ×
                    </button>
                )}
            </label>

            {/* Rows-per-page control (right-aligned, reuses Users styles) */}
            <div className="admin-table-controls users-tools desktop-search-box">
                <div className="admin-table-right">
                    <label className="rows-label">Rows:</label>
                    <select
                        value={pageSize}
                        onChange={(e) => { setPageSize(Number(e.target.value)); setPage(1); }}
                        className="rows-select"
                    >
                        {PAGE_SIZES.map(n => <option key={n} value={n}>{n}</option>)}
                    </select>
                </div>
            </div>
        </div>
    );
}